import CIMSTable from 'components/CIMSTable'
import DispositionTypesProvider, {
  useDispositionTypesContext,
} from './DispositionTypesContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'

const DispositionTypesTable: React.VFC = () => {
  const {
    dispositionTypes,
    loading,
    refetch: onReload,
  } = useDispositionTypesContext()
  return (
    <CIMSTable
      records={dispositionTypes}
      rowKey="id"
      loading={loading}
      columns={useColumns()}
      actions={{
        header: { onReload, create: useCreate() },
        row: { edit: useEdit(), restore: useRestore(), remove: useRemove() },
      }}
      expand={useExpand()}
    />
  )
}

const DispositionTypes: React.VFC = () => {
  return (
    <DispositionTypesProvider>
      <DispositionTypesTable />
    </DispositionTypesProvider>
  )
}

export default DispositionTypes
